import React, { createRef} from 'react'
import styled from 'styled-components'
import Icon from '../controls/icon-control'
import Button from '../controls/button-control'
import { FrontMatter } from '../lib/models'
import MapControl from './map-control'
import colours from '../lib/colours'
import { MaskChangedEvent } from '../lib/messages'
import Modal from "../components/modal";
import MobileMaskControl from '../controls/mask-control-mobile'


import IEventedComponent, {
  messageTypes
} from '../components/IEventedComponent'

const ButtonContainer = styled.div`
  z-index: 75;
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 14px;
`

const StyledRegionName = styled.h1`
  font-weight: 100;
  font-size: 20px;
  color: ${colours.white};
  text-align: left;
  height:45px;
  padding-top: 12px;
  padding-bottom: 9px;
  margin-bottom: 0px;
   font-weight: bold;
  `
const InvertedHeader = styled.div`
  :hover {
    color: ${colours.white};
  }
  cursor: pointer;
  font-weight: bold;
  background: ${colours.mediumBlue};
  color: ${colours.white};
  padding: 10px 26px 5px 26px;

`
const ContainerDiv = styled.div`
  height: 200px;
  width: 100%;
  background: ${colours.grey};
`
const CloseButton = styled.div`

  position:absolute;
  width:75px;
  left:220px;
  top:20px;
`
const EventStoppingDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 74;
`

interface IProps {
  frontMatter: FrontMatter
}

interface IState {
  isFullscreen: boolean,
  show: boolean
}

class MobileMapControl extends IEventedComponent<IProps, IState> {
 
  state: IState = {
    isFullscreen: false,
    show:false
  }

  onClickRegionMask = (maskIndex:number) => {
  const maskId = maskIndex
  this.publish<MaskChangedEvent>(messageTypes.onMaskChanged, {
        maskId
      })

        this.setState({ show: false });
  }

  componentDidMount() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
  }

  componentWillUnmount() {
    document.removeEventListener(
      'fullscreenchange',
      this.handleFullscreenChange
    )
  }

  handleFullscreenChange = () => {
    const isFullscreen = !!document.fullscreenElement
    this.setState({ isFullscreen })
  }
  
   showModal = () => {
    this.setState({ show: true });

      document.addEventListener("click", this.handleOutsideClick, false);
   };

      hideModal = () => {
       this.setState({ show: false });
       document.removeEventListener("click", this.handleOutsideClick, false);  
  };

  
  handleOutsideClick = e => {
    if (this.divRef.current?.contains(e.target)) this.hideModal();
  };

  handleFullscreen = () => {
    if (this.divRef.current?.requestFullscreen) {
      this.divRef.current?.requestFullscreen()
    }
    // not every device supports full screen :¬/
  }

  handleCloseFullscreen = () => document.exitFullscreen()

  divRef = createRef<HTMLDivElement>()

  render() {

    return (
       
      <ContainerDiv ref={this.divRef} >
        <Modal show={this.state.show} handleClose={this.hideModal}>
       <InvertedHeader>
             <StyledRegionName> 
               
                <CloseButton onClick={this.hideModal}><Icon icon="fa fa-times" /></CloseButton>
               </StyledRegionName>
     </InvertedHeader>
       
             <div onClick={()=> this.onClickRegionMask(3)} >
          <MobileMaskControl text="Barwon South West" />
          </div>
           <div onClick={()=> this.onClickRegionMask(5)} >
          <MobileMaskControl text="Gippsland"/>
          </div>
          <div onClick={()=> this.onClickRegionMask(7)} >
          <MobileMaskControl text="Grampians"/>
          </div>
          <div onClick={()=> this.onClickRegionMask(9)} >
          <MobileMaskControl text="Hume"/>
          </div>
          <div onClick={()=> this.onClickRegionMask(11)} >
          <MobileMaskControl text="Loddon Mallee"/>
          </div>
          <div onClick={()=> this.onClickRegionMask(13)} >
          <MobileMaskControl text="Metropoliton"/>
          </div>
                <div onClick={()=> window.open('https://plannedburns.ffm.vic.gov.au')} >
          <MobileMaskControl text="Planned Burns Vic"/>
          </div>
             
                <div onClick={()=> window.open('https://plannedburns.ffm.vic.gov.au')} >
          <MobileMaskControl text="Bushfire Management Strategies"/>
          </div>

        </Modal>
         <MapControl
          region={this.props.frontMatter?.region || 'unknown'}
          regionTitle={this.props.frontMatter?.title || 'Unknown Region'}
        />
   
       {!this.state.isFullscreen && (

        <ButtonContainer>
            <Button onClick= {this.showModal}>
               <Icon icon="bars" isImage />
               </Button>
          <Button onClick={()=> this.onClickRegionMask(0)}>
               <Icon icon="home" isImage />
               </Button>
          {!this.state.isFullscreen && this.divRef.current?.requestFullscreen && (
            <Button onClick={this.handleFullscreen}>
              <Icon icon="expand" isImage />
            </Button>
          )}
       
          </ButtonContainer>
             )}
          {this.state.isFullscreen && (
          
            <ButtonContainer>
            <Button onClick= {this.showModal}>
               <Icon icon="bars" isImage />
               </Button>
          <Button onClick={()=> this.onClickRegionMask(0)}>
               <Icon icon="home" isImage />
               </Button>
            <Button onClick={this.handleCloseFullscreen}>
              <Icon icon="expand" isImage />
            </Button>
            </ButtonContainer>
          )}
      </ContainerDiv>
    )
  }
}

export default MobileMapControl
